<template>
<div class="px-1">
    <div class="maleTitle">Cargar Datos Reproductivos Machos</div>

    <div class=" justify-center">
        <b-link :to="{name:'advance-dataupload'}"> <b-button class="bg-second maleButton " >Andrología</b-button></b-link>
    </div>
    <ControlMenu />
</div>
</template>


<script>
import { BButton, BLink } from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue'
export default {
    components:{
        BButton,
        ControlMenu,
        BLink,
    }
}
</script>

<style lang="scss">
.maleTitle {
    position: absolute;
    top: 10%;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    text-align: center;
}

.maleButton {
    position: absolute;
    top:45%;
    width:93%;
  
}
@import '@core/scss/vue/pages/page-auth.scss';
</style>